/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { useRoutes } from 'react-router-dom'
import getRoutes from 'tagliatelle/getRoutes.js'
import context from './webpackContext.mjs'

const Routes = () => {
  let routes = getRoutes({ context })
  return useRoutes(routes)
}

export default Routes

// /* Copyright 2013 - 2024 Waiterio LLC */
// import React from 'react'
// import { Redirect, Route, Switch } from 'react-router-dom'
// import DocumentsPage from './pages/DocumentsPage.js'
// import DocumentPage from './pages/DocumentPage.js'
// import NotFoundPage from './pages/NotFoundPage.js'
// import slugs from './slugs.js'

// const Routes = () => (
//   <Switch>

//     <Route
//       exact
//       path="/docs/:locale([a-z]{2})/"
//       render={({
//         match: {
//           params: { locale },
//         },
//       }) => <DocumentsPage locale={locale} />}
//     />
//     <Route
//       path="/docs/:locale([a-z]{2})/not-found/"
//       render={({
//         match: {
//           params: { locale },
//         },
//       }) => <NotFoundPage locale={locale} />}
//     />
//     <Route
//       path="/docs/:locale([a-z]{2})/:slug/"
//       render={({
//         match: {
//           params: { locale, slug },
//         },
//       }) => <DocumentPage locale={locale} slug={slug} />}
//     />

//     <Route path="*" exact component={NotFoundPage} />
//   </Switch>
// )

// export default Routes
